import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Box, Button, CircularProgress, Container, Typography } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { getListarEncuestas, postEncuestaReporte } from "../../../api/ApiService";
import { Add, Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import EncuestasHeader from "./components/EncuestasHeader";
import EncuestasFiltrosComponents from "./components/EncuestasFiltrosComponents";
import EncuestasTableComponent from "./components/EncuestasTableComponent";
import ReporteEncuestaModalComponents from "./components/ReporteEncuestaModalComponents";



export const statusOptions = [
    { label: 'Vigentes', value: "vigentes", id: 1 },
    { label: 'Inactivos', value: "inactivos", id: 2 },
    { label: 'Todos', value: "todos", id: 3 },
];

function EncuestasPage() {
    const [loading, setLoading] = useState(false);
    const [dataEncuestas, setDataEncuestas] = useState([]);

    const [statusFilter, setStatusFilter] = useState("todos");
    const [searchFilter, setSearchFilter] = useState("");
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);
    const [idEncuestaDelete, setIdEncuestaDelete] = useState(null);
    const [showDeleteEncuestaModal, setShowDeleteEncuestaModal] = useState(false);
    const [dataReporte, setDataReporte] = useState(null);

    const [openModal, setOpenModal] = useState(false);


    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.access_token);




    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (searchFilter.length > 2) {

                handleApiFiltrarEncuestasTituloEstado(searchFilter, statusFilter);
            } else {
                handleApiFiltrarEncuestas(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, searchFilter, statusFilter, perPage]);



    // useEffect(() => {
    //     if (stateToken) {
    //         // setDataUsuarios([]);
    //         // setLoading(true);
    //         handleListarEncuestas();
    //     }
    // }, [stateToken]);

    // const handleListarEncuestas = () => {

    //     getListarEncuestas(stateToken?.access_token)
    //         .then((response) => {
    //             // console.log("response-getUsuarios", response);
    //             if (response.data.length > 0) {
    //                 setDataEncuestas(response.data);
    //                 setLoading(true);
    //             } else {
    //                 setDataEncuestas([]);
    //                 setLoading(true);
    //             }
    //         })
    //         .catch((error) => {
    //             console.log("error-getUsuarios", error);
    //             setDataEncuestas([]);
    //             setLoading(true);
    //         });
    // };


















    // Funcion para agregar nueva encuesta
    const handleAddEncuesta = () => {
        history('/app/admin/encuestas/agregar');
    };


    //funcion para busqueda en el input
    const handleSearchChange = (value) => {
        setSearchFilter(value);
    };

    // funcion para cambiar el filtro de estado
    const handleStatusChange = (value) => {
        setStatusFilter(value);
    };






    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEncuestasTituloEstado = (titulo, estado) => {

        let body = {
            page: 1,
            per_page: perPage,
            estado: estado,
            titulo: titulo
        };
        console.log("body-handleApiFiltrarEncuestas", body);


        setLoadingCargar(true);

        getListarEncuestas(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getListarEncuestas", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataEncuestas(response.data);
                    setLoading(true);
                } else {
                    setDataEncuestas([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getListarEncuestas", error);
                setDataEncuestas([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };







    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEncuestas = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            estado: statusFilter,
            titulo: searchFilter
        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getListarEncuestas(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarEncuestas", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataEncuestas(response.data);
                    setLoading(true);
                } else {
                    setDataEncuestas([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarEncuestas", error);
                setDataEncuestas([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };


    // funcion para cambiar la cantidad de items por pagina
    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };



    const handleEditarItem = (item) => {
        history(`/app/admin/encuestas/editar/${item.id}`);
    };


    const handleOpenModalDeleteEncuesta = (idEncuesta) => {
        setIdEncuestaDelete(idEncuesta);
        setShowDeleteEncuestaModal(true);
    };




    //============================================================ funcion para generar reporte de encuestas
    const handleApiReporte = (id) => {

        let body = {
            encuesta_id: id,
        };


        setLoadingCargar(true);

        postEncuestaReporte(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>postEncuestaReporte", response);
                setLoadingCargar(false);
                setDataReporte(response?.url || null);
                setOpenModal(true);

            })
            .catch(error => {
                console.log("error==>postEncuestaReporte", error);
                setLoadingCargar(false);

            })
    };



    //=============================================funcion para descargar el qr
    const handleCloseModal = () => {
        setOpenModal(false);
    };


    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div className="max-w-7xl mx-auto">

                        <EncuestasHeader
                            title="Encuestas"
                            subtitle="Administra y supervisa las encuestas de la plataforma."
                            handleAdd={handleAddEncuesta}
                        />




                        <div>
                            <EncuestasFiltrosComponents
                                searchValue={searchFilter}
                                onSearchChange={handleSearchChange}
                                statusFilter={statusFilter}
                                onStatusChange={handleStatusChange}
                                statusOptions={statusOptions}
                            />

                            <EncuestasTableComponent
                                data={dataEncuestas}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarEncuestas}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditarItem}
                                handleOpenModalDelete={handleOpenModalDeleteEncuesta}
                                handleApiReporte={handleApiReporte}
                            />




                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}



                <ReporteEncuestaModalComponents
                    openModal={openModal}
                    handleCloseModal={handleCloseModal}
                    dataReporte={dataReporte}
                />

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}
export default EncuestasPage;